<template>
  <div :class="$style.plane" @click="onTileClick">
    <div :class="$style.picture">
      <img :class="$style.aircraftImage" :src="aircraft.image" alt="Aircraft" />
    </div>
    <div :class="$style.labelContainer">
      <img
        v-if="useDefault"
        :class="$style.statusIcon"
        alt=""
        src="/static/img/airplane_grey.svg"
      />
      <img
        v-if="aircraftActive"
        :class="$style.statusIcon"
        alt=""
        src="/static/img/airplane_green.svg"
      />
      <img
        v-if="aircraftInspectionSoon"
        :class="$style.statusIcon"
        alt=""
        src="/static/img/airplane_orange.svg"
      />
      <img
        v-if="aircraftGrounded"
        :class="$style.statusIcon"
        alt=""
        src="/static/img/airplane_red.svg"
      />
      <div :class="$style.nameContainer">
        <b :class="$style.tailNumber">{{ this.aircraft.tailNumber }}</b>
        <div :class="$style.model">{{ this.aircraft.model }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AircraftTile",
  props: {
    aircraft: null,
  },
  data() {
    return {
      aircraftActive: null,
      aircraftInspectionSoon: null,
      aircraftGrounded: null,
      useDefault: null,
    };
  },
  beforeMount() {
    switch (this.aircraft.aircraftStatus) {
      case "Active":
        this.aircraftActive = true;
        break;
      case "Inspection Due Soon":
        this.aircraftInspectionSoon = true;
        break;
      case "Grounded":
        this.aircraftGrounded = true;
        break;
      default:
        this.useDefault = true;
    }
  },
  methods: {
    onTileClick() {
      this.$emit("tile-clicked", this.aircraft);
    },
  },
});
</script>

<style module scoped>
.labelContainer {
  align-self: stretch;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 0px 20px;
  gap: 20px;
}
.plane {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 10px;
  margin-bottom: 40px;
  gap: 15px;
  cursor: pointer;
}
.aircraftImage {
  width: 225px;
  height: 225px;
  object-fit: cover;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.picture {
  width: 225px;
  position: relative;
  border-radius: 9px;
  background-color: #d9d9d9;
  height: 225px;
}
.statusIcon {
  width: 50px;
  position: relative;
  height: 50px;
}
.tailNumber {
  position: relative;
}
.model {
  position: relative;
  font-size: 13px;
  color: rgba(64, 64, 64, 0.5);
  text-align: left;
}
.nameContainer {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 5px;
}
</style>
